import { Loading } from 'src/components/atoms'

import type { OAuthCallbackStatus } from './use-oauth-callback'

export interface ICallbackTemplateProps {
  status: OAuthCallbackStatus
}

export const CallbackTemplate = ({
  status,
}: ICallbackTemplateProps): JSX.Element => (
  <main
    className="flex min-h-dvh items-center justify-center bg-surface-page"
    role="status"
    aria-live="polite"
    aria-label={status === 'failed' ? 'Returning to sign-in' : 'Signing you in'}
  >
    <Loading />
  </main>
)
